export default __webpack_public_path__ + "static/media/line-drawing.440196f6.png";